export default __webpack_public_path__ + "static/media/CircleBackArrow.b6288676.svg";